exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pwVenmo .BALANCE .fsIcons{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/venmo/venmo-balance.png\");background-repeat:no-repeat;background-size:30px 20px}.pwVenmo .venmoUsername{font-size:1em;line-height:1em;color:#6c7378;position:absolute;left:40px;top:55px}.pwVenmo .backup{color:#6c7378;text-align:center;margin-right:15px;margin-left:15px;margin-top:25px;font-size:.75em;line-height:1.154em}.pwVenmo .lineBreak{margin-top:20px;border-top:1px solid #e3e3e3}.pwVenmo .venmoReceipt{font-size:.95em;line-height:1.154em;margin:15px;text-align:center}.pwVenmo .learnMore p{text-align:center;color:#6c7378;font-size:.75em;line-height:1em;margin:0 30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader!./components/xo-venmo-components/src/review-paywith-venmo/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-venmo-components/src/review-paywith-venmo/styles.less
// module chunks = 1